/**
 * @generated SignedSource<<844982be8ff29a41bccbf6341edf2cdf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ConfigureActivityManagementRoundPlayerRate_Booking$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useGetActivityManagementPlayerRateOptions_Booking">;
  readonly " $fragmentType": "ConfigureActivityManagementRoundPlayerRate_Booking";
};
export type ConfigureActivityManagementRoundPlayerRate_Booking$key = {
  readonly " $data"?: ConfigureActivityManagementRoundPlayerRate_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConfigureActivityManagementRoundPlayerRate_Booking">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConfigureActivityManagementRoundPlayerRate_Booking",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetActivityManagementPlayerRateOptions_Booking"
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};

(node as any).hash = "4a6bebc341bedad9b49a6582b908ceeb";

export default node;
